/**
 * 车辆维保查询记录
 */
import React from 'react';

import { Row, Col, DatePicker, Input, Tooltip, Icon, Button } from 'antd';

import PageLayout from '../../ui/PageLayout';
//商户选择
import MemberSelect from '../../crm/member/MemberSelect';


import http from '../../../axios/http';

//加载中遮罩
import Loading from '../../ui/Loading';
import MaintenanceReport from './MaintenanceReport';
import messager from '../../ui/messager';

class VehicleFavoriteIndex extends React.Component {

    columns = [{
        title: '车架号',
        dataIndex: 'vin',
        width: '10%',
    }, {
        title: '车牌号',
        dataIndex: 'plateNo',
        width: '10%',
    }, {
        title: '商户名称',
        dataIndex: 'memberName',
        width: '10%',
    }, {
        title: '用户名称',
        dataIndex: 'username',
        width: '10%',
    }, {
        title: '报告类型',
        dataIndex: 'reportType',
        width: '10%',
        format: { 0: "基础版", 1: "综合版" }
    }, {
        title: '报告状态',
        dataIndex: 'status',
        width: '5%',
        format: { 0: "生成失败", 1: "已生成", 2: "生成中" }
    }, {
        title: '报告结果信息',
        dataIndex: 'message',
        width: '10%',
    }, {
        title: '查询时间',
        dataIndex: 'insertTime',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '5%',
        render: (text, record, index) => (
            <div>
                {record.status === 0 ? "" :
                    <Tooltip title="车辆维保信息详情">
                        <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                    </Tooltip>
                }
            </div>
        )
    }];

    state = {
        loadData: '',
        queryData: {},
        editData: {},
        loadingVisible: false
    };


    detail = (info, e) => {
        this.setState({ loadingVisible: true });
        if (info.status === 2) {
            http.get({
                url: '/maintenance/findReport',
                data: { id: info.id },
                success: (res) => {
                    this.setState({ editData: res, visible: true, loadingVisible: false });
                }, error: (res) => {
                    this.setState({ loadingVisible: false });
                }
            });
        } else {
            this.setState({ editData: info, visible: true, loadingVisible: false });
        }

    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    inputSearch = (field, key) => {
        let queryData = this.state.queryData;
        queryData[field] = key;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    memberSelect = (res) => {
        let queryData = this.state.queryData;
        queryData.memberCode = res;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    //导出数据
    download = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "") {
            messager.notify("请选择时间段进行导出！");
            return;
        }
        this.setState({ loadingVisible: true });
        queryData.pageNumber = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/maintenance/downloadReport',
            data: queryData,
            fileName: "维保查询记录.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="车架号"
                                    onSearch={this.inputSearch.bind(this, "vin")}
                                    enterButton
                                    style={{ width: '200px' }}
                                />
                                <MemberSelect mall={1} allowClear={true} onChange={this.memberSelect} style={{ width: '250px', margin: '0 10px' }} />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} />

                                <Button type="primary" onClick={this.download} style={{ "float": "right" }}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/maintenance/findReportPage"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <MaintenanceReport
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                />
                <Loading visible={this.state.loadingVisible} message="数据加载中..." />
            </div>
        )
    }
}

export default VehicleFavoriteIndex;